exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_RichText_2rXSL {\n  width: 100%;\n  word-break: break-word;\n  padding: 0.75rem;\n  background-color: #fff;\n}\n\n.index_RichText_2rXSL ul {\n  list-style: disc !important;\n  list-style-position: inside !important;\n}\n\n.index_RichText_2rXSL ol {\n  list-style-position: inside;\n}\n", ""]);

// Exports
exports.locals = {
	"RichText": "index_RichText_2rXSL"
};